import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotList from "./components/HotList";
import AnalysisPillars from "./components/AnalysisPillars";
import DeepDive from "./components/DeepDive";
import Playbook from "./components/Playbook";
import SpotTips from "./components/SpotTips";
import Faq from "./components/Faq";
import About from "./components/About";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import BackTop from "./components/BackTop";

const orgJsonLd = JSON.stringify({
  "@context": "https://schema.org",
  "@type": ["Organization", "WebSite"],
  name: "吃瓜透视局",
  url: "https://fujiejiaoyu.cn/",
  description:
    "吃瓜透视局专注吃瓜事件营销、背后推手、炒作真相与舆论引导的现象级分析，倡导理性吃瓜。",
  inLanguage: "zh-CN",
});

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: orgJsonLd }} />
      <Navbar />
      <main>
        <Hero />
        <HotList />
        <AnalysisPillars />
        <DeepDive />
        <Playbook />
        <SpotTips />
        <Faq />
        <About />
        <Newsletter />
      </main>
      <Footer />
      <BackTop />
    </>
  );
}